import { environment } from '@env/environment';

export default {
  Cognito: {
    userPoolId: environment.auth.userPoolId,
    userPoolClientId: environment.auth.webClientId,
    region: environment.auth.region,
    loginWith: {
      email: true,
    },
  },
};
